import React, { useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CASE_STUDIES } from "../../data/CaseStudiesData";
import "../../components/CaseStudyPage.css";
import { Button } from "../../components/Button";
import LightboxModal from "../../components/LightboxModal";

export default function CaseStudyPage() {
  const { slug } = useParams();
  const study = useMemo(
    () => CASE_STUDIES.find(cs => (cs.slug || "").replace(/^\/case-studies\//, "") === slug),
    [slug]
  );

  const [lbOpen, setLbOpen] = useState(false);
  const [lbIndex, setLbIndex] = useState(0);

  if (!study) {
    return (
      <main className="cs-wrap">
        <h1>Case Study not found</h1>
        <Link to="/portfolio">
          <Button className="btn-mobile" buttonStyle="btn--outline" buttonSize="btn--large">
            Back to Portfolio
          </Button>
        </Link>
      </main>
    );
  }

  const { title, hero, story, goals, results, tech, media } = study;

  return (
    <main className="cs-wrap">
      {/* Hero */}
      <section className="cs-hero">
        <img src={hero} alt={title} className="cs-hero-img" />
        <h1>{title}</h1>
        <p className="cs-story">{story}</p>
      </section>

      {/* Details */}
      <section className="cs-details">
        <div className="cs-col">
          <h2>Goals</h2>
          <ul>{goals.map((g,i)=><li key={i}>{g}</li>)}</ul>
        </div>
        <div className="cs-col">
          <h2>Results</h2>
          <ul>{results.map((r,i)=><li key={i}>{r}</li>)}</ul>
        </div>
        <div className="cs-col">
          <h2>Tech</h2>
          <ul>{tech.map((t,i)=><li key={i}>{t}</li>)}</ul>
        </div>
      </section>

      {/* Gallery */}
      {media?.length ? (
        <section className="cs-gallery">
          {media.map((m, i) => (
            <figure key={i} className={`cs-item ${m.type === "video" ? "is-video" : ""}`}
                    onClick={() => { setLbIndex(i); setLbOpen(true); }}>
              {m.type === "video" ? (
                <video src={m.src} className="cs-media" muted playsInline preload="metadata" />
              ) : (
                <img src={m.src} alt={`${title} ${i+1}`} className="cs-media" loading="lazy" />
              )}
            </figure>
          ))}
        </section>
      ) : null}

      {/* Lightbox */}
      {lbOpen && (
        <LightboxModal
          show={lbOpen}
          onHide={() => setLbOpen(false)}
          title={title}
          media={media}
          startIndex={lbIndex}
          interval={6000}
        />
      )}

      {/* CTA */}
      <section className="cs-cta">
        <h3>Want outcomes like this?</h3>
        <Link to="/contact">
          <Button className="btn-mobile" buttonStyle="btn--primary" buttonSize="btn--large">
            Get a Quote
          </Button>
        </Link>
      </section>
    </main>
  );
}
